import { render } from "./arrangement.vue?vue&type=template&id=77c09dbf"
import script from "./arrangement.vue?vue&type=script&lang=js"
export * from "./arrangement.vue?vue&type=script&lang=js"

import "./arrangement.vue?vue&type=style&index=0&id=77c09dbf&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__